<template>
  <div v-bind="$attrs" class="o-modal fixed flex items-center justify-center w-full h-full inset-0 z-modal-content" v-on="$listeners">
    <slot></slot>
  </div>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import { useLockScroll } from 'vue-composable';

export default defineComponent({
  setup() {
    useLockScroll('body');
  },
});
</script>
